const envCache = {};

/**
 * Helper for getting environment variables from the process.env.
 * If env variable is found, store it in envCache if not, throw error
 *
 * @param {string} key - the env key to get
 * @param {*} defaultValue - the default value that will be used
 *
 * @example
 *  getEnv('PORT', 4000)
 */
const getEnv = (key, defaultValue) => {
    if (!(key in process.env)) {
        if (defaultValue) return defaultValue;
        throw new Error(`No key ${key} in process.env!`);
    }
    if (envCache[key]) return envCache[key];

    envCache[key] = process.env[key];
    return envCache[key];
};

export default getEnv;
